<chat-redbird-ai [RBACORG]="RBACORG" [PERMISSION]="PERMISSION" [chatEvent]="chatEvent"></chat-redbird-ai>
